module.exports = __webpack_public_path__ + "static/media/dsc_logo.f65ee6f6.png";